import * as a from "react";
const e = (l) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M6.459 12.903a6 6 0 100-12 6 6 0 000 12zM3.876 5.427a.522.522 0 010-.736l.37-.37a.522.522 0 01.736 0l1.383 1.382a.13.13 0 00.188 0L7.936 4.32a.522.522 0 01.735 0l.37.37a.522.522 0 010 .737L7.66 6.809a.13.13 0 000 .188L9.068 8.38a.522.522 0 010 .735l-.37.37a.522.522 0 01-.736 0l-1.41-1.382a.13.13 0 00-.187 0L4.982 9.512a.522.522 0 01-.735 0l-.37-.37a.522.522 0 010-.736l1.382-1.409a.13.13 0 000-.188L3.876 5.427z",
      fill: "#333"
    }
  )
);
export {
  e as default
};
